<div class="row mt-5">
  <div class="offset-4 col-4">
    <section class="content">
      <div class="error-page">
        <h2 class="headline text-warning"> 404</h2>

        <div class="error-content">
          <h3><i class="fas fa-exclamation-triangle text-warning"></i> Oops! Pagina non trovata.</h3>

          <p>
            Non siamo riusciti a trovare la pagina cercata. Puoi tornare alla lista dei pazienti cliccando <a
              href="main/pazienti/listapazienti">qui</a>
          </p>
        </div>
        <!-- /.error-content -->
      </div>
      <!-- /.error-page -->
    </section>
  </div>
</div>